import { render, staticRenderFns } from "./ManageLayout.vue?vue&type=template&id=4b79cf9f&scoped=true&lang=pug&"
import script from "./ManageLayout.vue?vue&type=script&lang=js&"
export * from "./ManageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ManageLayout.vue?vue&type=style&index=0&id=4b79cf9f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79cf9f",
  null
  
)

export default component.exports